import "../css/JobForm.css";

export default function TractorDriverForm() {
  return (
    <div className="job-form-container">
      <h1>Apply – Tractor Driver</h1>
      <p>Field operations & machinery handling</p>

      <div className="job-form-grid">
        <input placeholder="Full Name" />
        <input placeholder="Mobile Number" />
        <input placeholder="Driving License Number" />
        <select>
          <option>Vehicles You Can Drive</option>
          <option>Tractor</option>
          <option>Truck</option>
          <option>Harvester</option>
        </select>
        <input placeholder="Years of Experience" />
        <textarea placeholder="Previous Work Details" />
      </div>

      <button>Submit Application</button>
    </div>
  );
}
